import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { Error } from './components/Error';
import { Layout } from './components/Layout';
import { LoaderProvider } from './components/LoaderProvider';
import { Menu } from './components/Menu';
import { ToastContainer } from './components/ToastContainer';
import { routes } from './constants/routes';
import Main from './pages/Main/Main';
import Mint from './pages/Mint/Mint';
import Missions from './pages/Missions/Missions';
import { store, toastManager } from './store';
import { decodeQueryParams, mapQueryParams } from './utils/query';

const App = observer(() => {
  const location = useLocation();

  useEffect(() => {
    const queryParams = mapQueryParams<{ tg: string }>(location.search);
    store.init(decodeQueryParams(queryParams.tg));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <Routes>
        <Route path="*" element={<Navigate to={routes.home} />} />
        <Route
          path={routes.error}
          element={
            <Error
              message={store.errorHandler.state.message}
              hasError={store.errorHandler.state.error}
            />
          }
        />
        <Route
          element={
            <LoaderProvider>
              <Menu />
            </LoaderProvider>
          }
        >
          <Route path={routes.home} element={<Main />} />
          <Route path={routes.mint} element={<Mint />} />
          <Route path={routes.missions} element={<Missions />} />
        </Route>
      </Routes>
      <ToastContainer
        toasts={toastManager.toasts}
        removeToast={toastManager.removeToast}
      />
    </Layout>
  );
});

export default App;
